import { $$, supportsIntersectionObserver } from '../../lib/dom';
import { trackObserver } from '../router/page-lifecycle';

const SECTION_IDS = ['advisory', 'practices', 'cre-portfolios', 'faq'];

/** Highlights the /solutions sub-navigation link of the section in view. */
export function initSubnav(root: HTMLElement): void {
  const links = $$('.subnav a', root);
  if (!supportsIntersectionObserver()) return;
  const observer = trackObserver(
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) links.forEach((a) => a.classList.toggle('on', a.dataset.sub === entry.target.id));
        });
      },
      { rootMargin: '-40% 0px -55% 0px' },
    ),
  );
  SECTION_IDS.forEach((id) => {
    const section = document.getElementById(id);
    if (section) observer.observe(section);
  });
}
